import _get from 'lodash/get';

const nonOptionFilters = [
    'zip',
    'location',
    'marketExtension',
    'keywordPhrases',
    'minPrice',
    'maxPrice',
    'startYear',
    'endYear',
    'productTypes',
];

const getSelectedFilterOptions = (filterOptions, filterValues) => Object.entries(filterValues).reduce((result, [originalFilterKey, filterValue]) => {
    const filterKey = originalFilterKey.indexOf('|') !== -1 ? originalFilterKey.split('|', 1)[0] : originalFilterKey;
    const filterOption = _get(filterOptions, originalFilterKey, _get(filterOptions, `${filterKey}.${originalFilterKey}`));

    if (!nonOptionFilters.includes(originalFilterKey)) {
        if (filterOption) {
            const { label, name } = filterOption;
            result.filterSelections.push({
                label,
                name,
                selectedOptions: _get(filterOption, 'options', [])
                    .filter(({ value }) => (Array.isArray(filterValue) ? filterValue.includes(value) : value === filterValue))
                    .map(({ label: optionLabel, value }) => ({ label: optionLabel, value })),
            });
        }
    } else {
        result[originalFilterKey] = {
            label: _get(filterOption, 'label', _get(filterOption, 'title', '')),
            name: _get(filterOption, 'name', ''),
            value: filterValue,
        };
    }
    return result;
}, { filterSelections: [] });

export default getSelectedFilterOptions;
